import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface LogoProps {
  variant?: "full" | "circular";
}

const Logo: React.FC<LogoProps> = ({ variant = "full" }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    // If we're already on the homepage, do a smooth refresh
    if (location.pathname === "/") {
      window.open("https://world-class.design/", "_blank");
      return;
    }
    // e.preventDefault();
    // Use state to trigger a refresh without visual interruption
    //   navigate('/', {
    //     window.open("https://world-class.design/", "_blank");
    //     replace: true,
    //     state: { refresh: true }
    //   });
    // }
    // Otherwise, let the Link component handle the navigation
  };

  const logoSrc = variant === "circular" ? "/wcd-logo.svg" : "/logo.svg";
  const logoClassName = variant === "circular" ? "h-10 w-10" : "h-10";

  return (
    <Link
      to="https://world-class.design/"
      onClick={handleClick}
      className="flex items-center justify-center hover:opacity-90 transition-opacity"
    >
      <img src={logoSrc} alt="World Class Design Logo" className={logoClassName} />
    </Link>
  );
};

export default Logo;
